import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { useAuthStore } from '@/modules/user/stores';

export const QUERY_KEY = 'getAccountNumberQueryKey';
export const useGetAccountNumberQuery = (accountId: string, enable?: boolean) => {
  const { auth } = useAuthStore();
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY, enable, accountId, auth],
    enable && accountId && auth
      ? () => api.get(API_URL.ACCOUNTS_HSA_NUMBER_BY_ACCOUNT_ID(accountId))
      : () => null
  );
  const formattedData = useMemo(
    () => ({
      accountNumber: data?.data.account_number || '',
      routingNumber: data?.data.routing_transit_number || '',
    }),
    [data]
  );

  return { isLoading, formattedData, isSuccess };
};
